import { Component, Input } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-uploaded-by-filter',
    templateUrl: './grid-uploaded-by-filter.component.html',
    styleUrls: ['./grid-uploaded-by-filter.component.scss'],
    standalone: false
})
export class GridUploadedByFilterComponent extends GridFilterBase<string> {
  @Input() searchString : string;
}